import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ChassisHeightRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: ChassisHeightRow[];
  loading?: boolean;
};

const renderValue = (
  value: string | number,
  styles: ReturnType<typeof useStyles>
) => <span className={styles.textCell}>{value}</span>;

const ChassisTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "manufacturerName",
        label: t("CHASSIS_HEIGHT.TABLE.MANUFACTURER"),
        align: "right",
        width: "12.5%",
        format: (row: ChassisHeightRow) =>
          renderValue(row.manufacturerName ?? "", styles),
      },
      {
        id: "superModelDesc",
        label: t("CHASSIS_HEIGHT.TABLE.MASTER_MODEL"),
        align: "right",
        width: "12.5%",
        format: (row: ChassisHeightRow) =>
          renderValue(row.superModelDesc ?? "", styles),
      },
      {
        id: "hangerType",
        label: t("CHASSIS_HEIGHT.TABLE.SUSPENSION_TYPE"),
        align: "right",
        width: "12.5%",
        format: (row: ChassisHeightRow) =>
          renderValue(row.hangerType, styles),
      },
      {
        id: "weelBase",
        label: t("CHASSIS_HEIGHT.TABLE.AXLE_DISTANCE"),
        align: "right",
        width: "12.5%",
        format: (row: ChassisHeightRow) =>
          renderValue(row.weelBase, styles),
      },
      {
        id: "tire",
        label: t("CHASSIS_HEIGHT.TABLE.TIRE"),
        align: "right",
        width: "12.5%",
        format: (row: ChassisHeightRow) => renderValue(row.tire, styles),
      },
      {
        id: "year",
        label: t("CHASSIS_HEIGHT.TABLE.YEAR"),
        align: "right",
        width: "12.5%",
        format: (row: ChassisHeightRow) => renderValue(row.year ?? "", styles),
      },
      {
        id: "height",
        label: t("CHASSIS_HEIGHT.TABLE.NET"),
        align: "right",
        width: "12.5%",
        format: (row: ChassisHeightRow) =>
          renderValue(row.height ?? "", styles),
      },
      {
        id: "heightIncludeBox",
        label: t("CHASSIS_HEIGHT.TABLE.CHASSIS_HEIGHT_INCLUDING_BODY"),
        align: "right",
        width: "12.5%",
        format: (row: ChassisHeightRow) =>
          renderValue(row.heightIncludeBox ?? "", styles),
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root} dir="rtl">
      <DataTable
        rows={rows}
        columns={columns}
        loading={loading && rows.length === 0}
        serialEnabled={false}
        noDataLabel={t("CHASSIS_HEIGHT.EMPTY")}
      />
    </div>
  );
};

export default ChassisTable;
